// extracted by mini-css-extract-plugin
export var icon = "TaggedTopics-module--icon--c8c4a";
export var label = "TaggedTopics-module--label--f8ae1";
export var tag = "TaggedTopics-module--tag--2be52";
export var tagswrapper = "TaggedTopics-module--tagswrapper--59c28";
export var tagwrapper = "TaggedTopics-module--tagwrapper--9b35c";